/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useRef } from 'react';
import {
  FormControl,
  TextField,
  Button,
  Skeleton,
  Autocomplete,
  createFilterOptions,
  CircularProgress,
  Chip,
  FormControlLabel,
  Switch,
  Tabs,
  Tab,
  Modal,
  IconButton,
  Typography,
  Select,
  MenuItem,
  Paper,
  Stepper,
  Step,
  StepLabel,
  Divider,
  Grid
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CloseIcon from '@mui/icons-material/Close';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import { Col, Row } from 'react-bootstrap';
import './GetRates.css';
import './KanbanCss.css';
import GuaranteeIcon from '../../assets/guaranteed.svg';
import Tooltip from '@mui/material/Tooltip';
import { useState } from 'react';
import FedExLogo from '../../assets/carrier logos/fedex.png';
import fedexExpress from '../../assets/carrier logos/fedexExpress.png';
import ABFLogo from '../../assets/carrier logos/ABFS.png';
import EXLALogo from '../../assets/carrier logos/EXLA.png';
import PITOHIO from '../../assets/carrier logos/PITD.png';
import CTLogo from '../../assets/carrier logos/central-transport.png';
import PYLELogo from '../../assets/carrier logos/PYLE.png';
import YRCLogo from '../../assets/carrier logos/RDWY.png';
import RLLogo from '../../assets/carrier logos/RLcarriers.png';
import WardLogo from '../../assets/carrier logos/WARD.png';
import AACTLogo from '../../assets/carrier logos/AACT.png';
import AVERITTLogo from '../../assets/carrier logos/AVRT.png';
import GLSLogo from '../../assets/carrier logos/GLS.png';
import SMTLLogo from '../../assets/carrier logos/smtl.png';
import UPSLogo from '../../assets/carrier logos/Tfroce freight.png';
import UPSOldLogo from '../../assets/carrier logos/ups.png';
import ODFLlogo from '../../assets/carrier logos/ODFL.png';
import SEFLlogo from '../../assets/carrier logos/Southeastern freight lines.png';
import NEWPENLogo from '../../assets/carrier logos/New Penn.png';
import SAIALogo from '../../assets/carrier logos/SAIA.png';
import CNWYLogo from '../../assets/carrier logos/CNWY.png';
import ReddawayLogo from '../../assets/carrier logos/Reddaway.png';
import { Box } from '@mui/system';
import { styled } from '@mui/material/styles';
import { tooltipClasses } from '@mui/material/Tooltip';
import DialogTitle from '@mui/material/DialogTitle';
import PhoneAndroidOutlinedIcon from '@mui/icons-material/PhoneAndroidOutlined';
import { useStyles } from '../../pages/GetQoute/styles';
import { base_logo_url } from '../../apis/constants';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useIsMobile } from '../../components/IsMobileHook/IsMobileHook';

function QuickQuoteTabPanel({
  OriginLocation,
  DestinationLocation,
  OrderWeight,
  selectedClass,
  errorMessageApi,
  quote,
  fetchData,
  obj,
  SelectedRowData,
  successRates,
  EstesApiLoading,
  checkedProp,
  shipTypeValue,
  noAssignedCarriers,
  selectedLocation,
  bookingData,
  allRatesFetched,
  onSelectRate,
  selectedRate
}) {
  const [open, setOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [bookedRate, setBookedRate] = useState(null);
  const [soNumber, setSoNumber] = useState('');
  const [coNumber, setCoNumber] = useState('');
  const history = useHistory();
  const descriptionElementRef = useRef(null);
  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  const options = {
    // weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  };
  // const [EstesApiLoading, setEstesApiLoading] = useState(false);
  const [defaultOriginLoc, setDefaultOriginLoc] = useState(OriginLocation);
  const [defaultDestinationLoc, setDefaultDestinationLoc] =
    useState(DestinationLocation);

  const [shipFromOpen, setShipFromOpen] = useState(false);
  const [shipToOpen, setShipToOpen] = useState(false);
  const [shipCity, setShipCity] = useState([]);
  const [ErrMsgArray, setErrMsgArray] = useState();
  const [shipFromHoveredValue, setShipFromHoveredValue] = useState(null);
  const [shipToHoveredValue, setShipToHoveredValue] = useState(null);
  const [freightClassHoveredValue, setFreightClassHoveredValue] =
    useState(null);

  const dateNow = new Date();
  const year = dateNow.getFullYear();
  const monthWithOffset = dateNow.getUTCMonth() + 1;
  const month =
    monthWithOffset.toString().length < 2
      ? `0${monthWithOffset}`
      : monthWithOffset;
  const date =
    dateNow.getUTCDate().toString().length < 2
      ? `0${dateNow.getUTCDate()}`
      : dateNow.getUTCDate();

  const materialDateInput = `${year}-${month}-${date}`;

  const [state, setState] = useState({
    open: false,
    vertical: 'top',
    horizontal: 'center'
  });

  let TempOrigin = OriginLocation.split(' ');
  let FinalOrigin = {};

  const City = TempOrigin[0];
  const State = TempOrigin[1];
  const ZipCode = TempOrigin[2];
  const CountryCode = TempOrigin[3];
  FinalOrigin = {
    City,
    State,
    ZipCode,
    CountryCode
  };

  let TempDestination = DestinationLocation.split(' ');
  let FinalDestination = {};

  const City2 = TempDestination[0];
  const State2 = TempDestination[1];
  const ZipCode2 = TempDestination[2];
  const CountryCode2 = TempDestination[3];
  FinalDestination = {
    City2,
    State2,
    ZipCode2,
    CountryCode2
  };
  console.log(FinalDestination, 'FinalDestination');
  const [shipFromFinalAddress, setShipFromFinalAddress] = useState(FinalOrigin);
  const ShipFromloading = shipFromOpen && options.length === 0;
  const ShipToLoading = shipToOpen && options.length === 0;
  const [validationErrors, setValidationErrors] = useState({});
  const [shipFromErr, setShipFromErr] = useState(false);
  const [shipToFinalAddress, setShipToFinalAddress] =
    useState(FinalDestination);
  const [requoteWeight, setRequoteWeight] = useState(OrderWeight);
  const [requoteClass, setRequoteClass] = useState(selectedClass);

  // const handleUSAddresses = () => {
  //   let tempCity = [];
  //   for (let index = 0; index < USALocations.length; index++) {
  //     const City = USALocations[index].city;
  //     const State = USALocations[index].state;
  //     const ZipCode = USALocations[index].zip_code;

  //     const CountryCode = USALocations[index].country_code;

  //     tempCity.push(City + ' ' + State + ' ' + ZipCode + ' ' + CountryCode);
  //     // tempState.push(State);
  //     // tempZipCode.push(ZipCode);
  //   }
  //   setShipCity(tempCity);
  //   // setShipState(tempState);
  //   // setShipZip(tempZipCode);
  // };
  // useEffect(() => {
  //   handleUSAddresses();
  // }, []);

  const LoadingArray = [
    { item: 1 },
    { item: 1 },
    { item: 1 },
    { item: 1 },
    { item: 1 }
  ];
  const ErrorMessageApiHanlder = () => {
    var ErrMsgArray = [
      { title: 'CTQuoteRate', msg: '', logo: CTLogo },
      {
        title: 'FedEx',
        msg: '',
        logo: shipTypeValue === 'Parcel' ? fedexExpress : FedExLogo
      },
      { title: 'XPO', msg: '', logo: CNWYLogo },
      { title: 'Estes', msg: '', logo: EXLALogo },
      { title: 'SAIA', msg: '', logo: SAIALogo },
      { title: 'ABF', msg: '', logo: ABFLogo },
      { title: 'PittOhio', msg: '', logo: PITOHIO },
      { title: 'Sefl', msg: '', logo: SEFLlogo },
      { title: 'NewPenn', msg: '', logo: NEWPENLogo },
      { title: 'ODFL', msg: '', logo: ODFLlogo },
      {
        title: 'UPS',
        msg: '',
        logo: shipTypeValue === 'Parcel' ? UPSOldLogo : UPSLogo
      },
      {
        title: 'YRC',
        msg: '',
        logo: YRCLogo
      },
      { title: 'Reddaway', msg: '', logo: ReddawayLogo },
      { title: 'Ward', msg: '', logo: WardLogo },
      { title: 'RL', msg: '', logo: RLLogo },
      { title: 'AduiePyle', msg: '', logo: PYLELogo },
      { title: 'AAACooper', msg: '', logo: AACTLogo },
      { title: 'Averitt', msg: '', logo: AVERITTLogo },
      { title: 'GLS', msg: '', logo: GLSLogo },
      { title: 'SMTL', msg: '', logo: SMTLLogo }
    ];
    const FinalErrArray = [];
    for (let i = 0; i < errorMessageApi.length; i++) {
      const errorApi = errorMessageApi[i];
      const ErrName = errorApi?.URL?.split('/');
      const LastName = ErrName[ErrName?.length - 1];
      const errorMsgPair = {
        message: errorApi?.message
      };
      FinalErrArray.push({
        // title: LastName,
        msg:
          errorApi.message.length > 2
            ? errorApi.message
            : JSON.stringify(errorMsgPair, null, 2),
        logo: ErrMsgArray.find(items =>
          LastName.includes(items.title) ? items.logo : null
        )
      });
    }
    setErrMsgArray(FinalErrArray);
  };

  useEffect(() => {
    ErrorMessageApiHanlder();
  }, [errorMessageApi]);

  useEffect(() => () => setState({ open: false }), []);

  const RateErrorTooltip = styled(({ className, ...props }) => (
    <Tooltip arrow {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#ce7a7a',
      color: 'white',
      maxWidth: 800,
      // width: 1900,
      // margin: '0 10 0 10 ',
      fontSize: theme.typography.pxToRem(12)
      // border: '1px solid #dadde9'
    },
    [`& .${tooltipClasses.arrow}`]: {
      // backgroundColor: '#f5f5f9',
      color: '#ce7a7a',
      maxWidth: 1100,
      // width: 1900,
      // margin: '0 10 0 10 ',
      fontSize: theme.typography.pxToRem(12)
      // border: '1px solid #dadde9'
    }
  }));

  const onShipFromChange = (event, values) => {
    let FinalObj = {};
    var filtered = [];
    if (values !== null) {
      filtered = shipCity.filter(option =>
        option?.toLowerCase().includes(values?.toLowerCase())
      );
    }
    setShipFromHoveredValue(filtered[0]);
    if (values !== null) {
      setDefaultOriginLoc(values);
      const tempData = values.split(' ');
      if (tempData.length === 4) {
        const updatedErrors = { ...validationErrors, shipFromErr: null };
        setValidationErrors(updatedErrors);
        const City = tempData[0];
        const State = tempData[1];
        const ZipCode = tempData[2];
        const CountryCode = tempData[3];
        FinalObj = {
          City,
          State,
          ZipCode,
          CountryCode
        };
      } else if (tempData.length === 6) {
        const City = tempData[0] + ' ' + tempData[1] + ' ' + tempData[2];
        const State = tempData[3];
        const ZipCode = tempData[4];
        const CountryCode = tempData[5];
        FinalObj = {
          City,
          State,
          ZipCode,
          CountryCode
        };
      } else {
        const City = tempData[0] + ' ' + tempData[1];
        const State = tempData[2];
        const ZipCode = tempData[3];
        const CountryCode = tempData[4];

        FinalObj = {
          City,
          State,
          ZipCode,
          CountryCode
        };
      }

      setShipFromFinalAddress(FinalObj);
    } else {
      // setShipFromFinalAddress('');
    }
  };

  const onShipToChange = (event, values) => {
    let FinalObj2 = {};
    var filtered = [];
    if (values !== null) {
      filtered = shipCity.filter(option =>
        option?.toLowerCase().includes(values?.toLowerCase())
      );
    }
    setShipToHoveredValue(filtered[0]);
    if (values !== null) {
      setDefaultDestinationLoc(values);
      setShipFromErr(false);
      const tempData = values.split(' ');
      if (tempData.length === 4) {
        const updatedErrors = { ...validationErrors, shipToErr: null };
        setValidationErrors(updatedErrors);
        const City2 = tempData[0];
        const State2 = tempData[1];
        const ZipCode2 = tempData[2];
        const CountryCode2 = tempData[3];
        FinalObj2 = {
          City2,
          State2,
          ZipCode2,
          CountryCode2
        };
        setShipToFinalAddress(FinalObj2);
      } else if (tempData.length === 6) {
        const City2 = tempData[0] + ' ' + tempData[1] + ' ' + tempData[2];
        const State2 = tempData[3];
        const ZipCode2 = tempData[4];
        const CountryCode2 = tempData[5];

        FinalObj2 = {
          City2,
          State2,
          ZipCode2,
          CountryCode2
        };
        setShipToFinalAddress(FinalObj2);
      } else {
        const City2 = tempData[0] + ' ' + tempData[1];
        const State2 = tempData[2];
        const ZipCode2 = tempData[3];
        const CountryCode2 = tempData[4];
        FinalObj2 = {
          City2,
          State2,
          ZipCode2,
          CountryCode2
        };
        setShipToFinalAddress(FinalObj2);
      }
      // setShipToFinalAddress(FinalObj2);
      console.log(FinalObj2, 'FinalObj2');
    } else {
      setShipToFinalAddress('');
      setShipFromErr(true);
    }
  };
  const filterOptions = createFilterOptions({
    limit: 100
  });

  const handleRequote = () => {
    const reg = /^-?\d+\.?\d*$/;
    let RequoteObj = JSON.parse(JSON.stringify(obj));
    let DeepCloneRequoteObj = JSON.parse(JSON.stringify(obj));

    // let newObj = { ...obj, };
    // if (
    //   // regex.test(shipFromFinalAddress.City) &&
    //   shipFromFinalAddress.City.length >= 3
    // ) {
    RequoteObj.shipFrom.city = shipFromFinalAddress.City;
    DeepCloneRequoteObj.shipFrom.city = shipFromFinalAddress.City;
    // }
    // if (shipFromFinalAddress.State.length === 2) {
    RequoteObj.shipFrom.stateOrProvinceCode = shipFromFinalAddress.State;
    DeepCloneRequoteObj.shipFrom.stateOrProvinceCode =
      shipFromFinalAddress.State;
    // }
    // if (
    // reg.test(shipFromFinalAddress.ZipCode) &&
    // (shipFromFinalAddress.ZipCode.length === 5 ||
    //   shipFromFinalAddress.ZipCode.length === 6)
    // ) {
    RequoteObj.shipFrom.postalCode = shipFromFinalAddress.ZipCode;
    DeepCloneRequoteObj.shipFrom.postalCode = shipFromFinalAddress.ZipCode;
    // }

    // if (
    // reg.test(shipFromFinalAddress.ZipCode) &&
    // shipFromFinalAddress.CountryCode.length === 3
    // ) {
    RequoteObj.shipFrom.countryCode = shipFromFinalAddress.CountryCode;
    DeepCloneRequoteObj.shipFrom.countryCode = shipFromFinalAddress.CountryCode;
    // }
    // if (
    // regex.test(shipToFinalAddress.City2) &&
    // shipToFinalAddress.City2.length >= 3
    // ) {
    RequoteObj.shipTo.city = shipToFinalAddress.City2;
    DeepCloneRequoteObj.shipTo.city = shipToFinalAddress.City2;
    // }
    // if (shipToFinalAddress.State2.length === 2) {
    RequoteObj.shipTo.stateOrProvinceCode = shipToFinalAddress.State2;
    DeepCloneRequoteObj.shipTo.stateOrProvinceCode = shipToFinalAddress.State2;
    // }
    // if (
    //   reg.test(shipFromFinalAddress.ZipCode) &&
    //   (shipToFinalAddress.ZipCode2.length === 5 ||
    //     shipToFinalAddress.ZipCode2.length === 6)
    // ) {
    RequoteObj.shipTo.postalCode = shipToFinalAddress.ZipCode2;
    DeepCloneRequoteObj.shipTo.postalCode = shipToFinalAddress.ZipCode2;
    // }
    // if (
    // reg.test(shipFromFinalAddress.ZipCode) &&
    //   shipToFinalAddress.CountryCode2.length === 3
    // ) {
    RequoteObj.shipTo.countryCode = shipToFinalAddress.CountryCode2;
    DeepCloneRequoteObj.shipTo.countryCode = shipToFinalAddress.CountryCode2;
    // }
    RequoteObj.shipTo.streetLines =
      shipToFinalAddress.City2 +
      ' ' +
      shipToFinalAddress.State2 +
      ' ' +
      shipToFinalAddress.ZipCode2 +
      ' ' +
      shipToFinalAddress.CountryCode;
    RequoteObj.shipFrom.streetLines =
      shipFromFinalAddress.City +
      ' ' +
      shipFromFinalAddress.State +
      ' ' +
      shipFromFinalAddress.ZipCode +
      ' ' +
      shipFromFinalAddress.CountryCode;
    RequoteObj.commodityInfo[0].weight.value = requoteWeight;
    RequoteObj.commodityInfo[0].freightClass = requoteClass;
    DeepCloneRequoteObj.commodityInfo[0].weight.value = requoteWeight;
    DeepCloneRequoteObj.commodityInfo[0].freightClass = requoteClass;

    // DeepCloneRequoteObj.shipFrom.countryCode = 'US';
    // DeepCloneRequoteObj.shipTo.countryCode = 'US';

    console.log(RequoteObj, 'RequoteObj');
    fetchData(RequoteObj, DeepCloneRequoteObj);

    // window.location.reload();
  };

  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(checkedProp);
  }, [checkedProp]);

  const handleShowHideErrosChnage = event => {
    setChecked(event.target.checked);
  };

  // state for storing the isotope object, with an initial value of null
  // state for storing the filter keyword, with an initial value of *, which matches everything
  const [filterKey, setFilterKey] = useState('*');
  const [sortKey, setSortKey] = useState('price');
  const [sortOrder, setSortOrder] = useState('ASC');

  const [detailDrawer, setDetailDrawer] = useState(false);
  const [detailModal, setDetailModal] = useState(false);

  const [filterValue, setFilterValue] = useState(0);
  const [sortValue, setSortValue] = useState(0);

  const [currentRate, setCurrentRate] = useState({});

  const handleFilterValueChange = (event, newValue) => {
    setFilterValue(newValue);
  };
  const handleSortValueChange = (event, newValue) => {
    setSortValue(newValue);
  };

  const handleSortToggle = () => {
    setSortOrder(prevOrder => (prevOrder === 'ASC' ? 'DESC' : 'ASC'));
  };

  const handleViewRate = rate => {
    setCurrentRate(rate);
    setDetailDrawer(true);
  };

  const handleViewRate1 = rate => {
    setCurrentRate(rate);
    setDetailModal(true);
  };

  const handleSelectRate = rate => {
    if (onSelectRate) onSelectRate(rate);
  };

  const handleBookRate = item => {
    setBookedRate(item);
    setSoNumber('');
    setCoNumber('');
    setActiveStep(2);
  };

  const handleConfirmPickup = () => {
    const bookingData = {
      ...obj,
      carrierName: bookedRate?.carrierInfo?.name,
      carrierLogo: bookedRate?.carrierInfo?.logo,
      totalAmount: bookedRate?.totalNetCharge?.amount,
      transitTime: bookedRate?.transitTime,
      deliveryTime: bookedRate?.deliveryTime,
      serviceType: bookedRate?.serviceType,
      isGuaranteedDelivery: bookedRate?.isGuaranteedDelviery,
      quotationNumber: bookedRate?.quotationNumber,
      surcharges: bookedRate?.surcharges,
      soNumber,
      coNumber
    };
    const route =
      shipTypeValue === 'Parcel' ? '/bookshipmentParcel' : '/bookshipment';
    history.push(route, { pickupRowData: JSON.stringify(bookingData) });
  };

  const isSelected = rate =>
    selectedRate && rate.uniqueId === selectedRate.uniqueId;

  const applyFilter = item => {
    switch (filterKey) {
      case '*':
        return true;
      case 'guaranteed':
        return item.isGuaranteedDelviery;
      case 'standard':
        return item.filterMode === 'standard';
      default:
        return false;
    }
  };

  const applySort = (rowA, rowB) => {
    switch (sortKey) {
      case 'price':
        return sortOrder === 'ASC'
          ? rowA.totalNetCharge.amount - rowB.totalNetCharge.amount
          : rowB.totalNetCharge.amount - rowA.totalNetCharge.amount;
      case 'days':
        const daysA = isNaN(parseInt(rowA.transitTime))
          ? 9999
          : parseInt(rowA.transitTime);
        const daysB = isNaN(parseInt(rowB.transitTime))
          ? 9999
          : parseInt(rowB.transitTime);
        return sortOrder === 'ASC' ? daysA - daysB : daysB - daysA;
      case 'name':
        return sortOrder === 'ASC'
          ? rowA.carrierInfo.name.localeCompare(rowB.carrierInfo.name)
          : rowB.carrierInfo.name.localeCompare(rowA.carrierInfo.name);
      default:
        return 0; // Default case: no sorting
    }
  };

  const applySubChargesSort = (rowA, rowB) => {
    return rowA.order - rowB.order;
  };

  const formatePrice = price => {
    return price?.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    backgroundColor: 'white',
    maxHeight: '90vh',
    overflowY: 'auto'
  };

  const mobileStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    backgroundColor: 'white',
    maxHeight: '90vh',
    overflowY: 'auto'
  };
  const maxLimit = 14999;
  const maxLimitParcel = 150;

  const handleReQuoteWeightChange = e => {
    const inputValue = e.replace(/[^0-9]/g, '');
    if (shipTypeValue === 'Parcel') {
      if (parseInt(inputValue, 10) > maxLimitParcel) {
        // setRequoteWeight(String(maxLimit));
        const updatedErrors = {
          ...validationErrors,
          newAddedDimensionsRow: 'Maximum weight limit is 150 lbs'
        };
        setValidationErrors(updatedErrors);
      } else {
        const updatedErrors = {
          ...validationErrors,
          newAddedDimensionsRow: null
        };
        setValidationErrors(updatedErrors);
        setRequoteWeight(inputValue);
      }
    } else if (shipTypeValue === 'LTL' && parseInt(inputValue, 10) > maxLimit) {
      // setRequoteWeight(String(maxLimit));
      const updatedErrors = {
        ...validationErrors,
        newAddedDimensionsRow: 'Maximum weight limit is 14999'
      };
      setValidationErrors(updatedErrors);
    } else {
      const updatedErrors = {
        ...validationErrors,
        newAddedDimensionsRow: null
      };
      setValidationErrors(updatedErrors);
      setRequoteWeight(inputValue);
    }
  };
  const ClassArray = [
    '50',
    '55',
    '60',
    '65',
    '70',
    '77.5',
    '85',
    '92.5',
    '100',
    '110',
    '125',
    '150',
    '175',
    '200',
    '250',
    '300',
    '400',
    '500'
  ];
  const requoteClassChange = (event, newValue) => {
    var filteredClass = [];
    if (event !== null) {
      setRequoteClass(newValue);
      filteredClass = ClassArray.filter(option =>
        option.toLowerCase().includes(newValue?.toLowerCase())
      );
    }
    setFreightClassHoveredValue(filteredClass[0]);
  };
  const classes = useStyles();
  const isMobile = useIsMobile();

  return (
    <div style={{ width: '100%' }}>
      <React.Fragment>
        <Modal
          open={detailModal}
          onClose={() => setDetailModal(false)}
          aria-labelledby='modal-modal-title'
          aria-describedby='modal-modal-description'
        >
          <Box
            className=' py-3 d-flex flex-column detail-bottom-drawer'
            style={isMobile ? mobileStyle : style}
          >
            <DialogTitle sx={{ m: 0, p: 2 }}>
              <IconButton
                onClick={() => setDetailModal(false)}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  color: theme => theme.palette.grey[500]
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <div
              className=' py-3 mt-4 d-flex flex-column '
              style={{ width: '97%' }}
            >
              <Row
                className='px-3 d-flex flex-row'
                style={{ marginTop: '-30', marginBottom: -10 }}
              >
                <Col style={{ display: 'flex', alignItems: 'center' }}>
                  <div className=''>
                    <img
                      alt={'st'}
                      src={
                        `${base_logo_url}carrier_logos/` +
                        currentRate?.carrierInfo?.logo
                      }
                      width={isMobile ? 50 : 90}
                    />
                  </div>
                </Col>
                <Col style={{ display: 'flex', alignItems: 'center' }}>
                  <div className='d-block'>
                    <Typography
                      variant='h4'
                      className='fw-bold'
                      style={{ textAlign: 'center' }}
                    >
                      <span className='dayss'>
                        {isNaN(parseInt(currentRate.transitTime))
                          ? 'N/A'
                          : currentRate.transitTime === '0'
                            ? 'N/A'
                            : parseInt(currentRate.transitTime)}
                      </span>
                    </Typography>
                    <Typography
                      variant='body1'
                      className='text-black'
                      style={
                        isMobile
                          ? { fontSize: '11px', textAlign: 'center' }
                          : { fontSize: '13px', textAlign: 'center' }
                      }
                    >
                      Service Day(s)
                    </Typography>
                  </div>
                </Col>
              </Row>
              <Row className='px-3 d-flex flex-row' style={{}}>
                <Col>
                  <div className='my-2'>
                    <Typography
                      variant={isMobile ? 'body2' : 'h6'}
                      className=''
                      style={{ color: '#1565c0' }}
                    >
                      Origin Terminal Info
                    </Typography>
                    <Typography variant='body1' className=' fw-bold' style={{}}>
                      Address
                    </Typography>
                    <Typography
                      variant='h5'
                      className={
                        isMobile
                          ? 'info-label-value_mobile'
                          : 'info-label-value'
                      }
                    >{`${
                      currentRate?.originDetail?.contactAndAddress?.address
                        .streetLines
                        ? currentRate?.originDetail?.contactAndAddress?.address
                            .streetLines
                        : ' '
                    }`}</Typography>
                    <Typography
                      variant='h5'
                      className={
                        isMobile
                          ? 'info-label-value_mobile'
                          : 'info-label-value'
                      }
                    >{`${
                      currentRate?.originDetail?.contactAndAddress?.address.city
                        ? currentRate?.originDetail?.contactAndAddress?.address
                            .city + ','
                        : ' '
                    } ${
                      currentRate?.originDetail?.contactAndAddress?.address
                        .stateOrProvinceCode
                        ? currentRate?.originDetail?.contactAndAddress?.address
                            .stateOrProvinceCode + ','
                        : ''
                    } ${
                      currentRate?.originDetail?.contactAndAddress?.address
                        .postalCode
                        ? currentRate?.originDetail?.contactAndAddress?.address
                            .postalCode
                        : ''
                    }`}</Typography>
                    <Typography variant='body1' className=' fw-bold' style={{}}>
                      Phone
                    </Typography>
                    <Typography
                      variant='h5'
                      className={
                        isMobile
                          ? 'info-label-value_mobile'
                          : 'info-label-value'
                      }
                    >
                      <PhoneAndroidOutlinedIcon
                        style={{
                          height: 18,
                          width: 18
                        }}
                      />
                      {currentRate?.originDetail?.contactAndAddress?.contact
                        .phoneNumber ? (
                        <a
                          className='call-phone-number'
                          href={`tel:${currentRate?.originDetail?.contactAndAddress?.contact.phoneNumber}`}
                        >
                          {currentRate?.originDetail?.contactAndAddress?.contact.phoneNumber.replace(
                            /\D/g,
                            ''
                          ).length < 11
                            ? currentRate?.originDetail?.contactAndAddress?.contact.phoneNumber
                                .replace(/\D/g, '')
                                .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
                            : currentRate?.originDetail?.contactAndAddress
                                ?.contact.phoneNumber}
                        </a>
                      ) : (
                        ' '
                      )}
                    </Typography>
                  </div>
                </Col>
                <Col>
                  <div className='my-2'>
                    <Typography
                      variant={isMobile ? 'body2' : 'h6'}
                      className=''
                      style={{ color: '#1565c0' }}
                    >
                      Destination Terminal Info
                    </Typography>
                    <Typography variant='body1' className=' fw-bold' style={{}}>
                      Address
                    </Typography>
                    <Typography
                      variant='h5'
                      className={
                        isMobile
                          ? 'info-label-value_mobile'
                          : 'info-label-value'
                      }
                    >{`${
                      currentRate?.destinationDetail?.contactAndAddress?.address
                        .streetLines
                        ? currentRate?.destinationDetail?.contactAndAddress
                            ?.address.streetLines
                        : ' '
                    }`}</Typography>
                    <Typography
                      variant='h5'
                      className={
                        isMobile
                          ? 'info-label-value_mobile'
                          : 'info-label-value'
                      }
                    >{`${
                      currentRate?.destinationDetail?.contactAndAddress?.address
                        .city
                        ? currentRate?.destinationDetail?.contactAndAddress
                            ?.address.city + ','
                        : ' '
                    } ${
                      currentRate?.destinationDetail?.contactAndAddress?.address
                        .stateOrProvinceCode
                        ? currentRate?.destinationDetail?.contactAndAddress
                            ?.address.stateOrProvinceCode + ','
                        : ''
                    } ${
                      currentRate?.destinationDetail?.contactAndAddress?.address
                        .postalCode
                        ? currentRate?.destinationDetail?.contactAndAddress
                            ?.address.postalCode
                        : ''
                    }`}</Typography>
                    <Typography variant='body1' className=' fw-bold' style={{}}>
                      Phone
                    </Typography>
                    <Typography
                      variant='h5'
                      className={
                        isMobile
                          ? 'info-label-value_mobile'
                          : 'info-label-value'
                      }
                    >
                      <PhoneAndroidOutlinedIcon
                        style={{
                          height: 18,
                          width: 18
                        }}
                      />
                      {currentRate?.destinationDetail?.contactAndAddress
                        ?.contact.phoneNumber ? (
                        <a
                          className='call-phone-number'
                          href={`tel:${currentRate?.destinationDetail?.contactAndAddress?.contact.phoneNumber}`}
                        >
                          {currentRate?.destinationDetail?.contactAndAddress?.contact.phoneNumber.replace(
                            /\D/g,
                            ''
                          ).length < 11
                            ? currentRate?.destinationDetail?.contactAndAddress?.contact.phoneNumber
                                .replace(/\D/g, '')
                                .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
                            : currentRate?.destinationDetail?.contactAndAddress
                                ?.contact.phoneNumber}
                        </a>
                      ) : (
                        ' '
                      )}
                    </Typography>
                  </div>
                </Col>
              </Row>
            </div>
          </Box>
        </Modal>

        <Modal
          open={detailDrawer}
          onClose={() => setDetailDrawer(false)}
          aria-labelledby='modal-modal-title'
          aria-describedby='modal-modal-description'
        >
          <Box
            className=' py-3 d-flex flex-column detail-bottom-drawer'
            style={isMobile ? mobileStyle : style}
          >
            <DialogTitle sx={{ m: 0, p: 2 }}>
              <IconButton
                onClick={() => setDetailDrawer(false)}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  color: theme => theme.palette.grey[500]
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <div
              className=' py-3 mt-4 d-flex flex-column '
              style={{ width: '97%' }}
            >
              <Row
                className='px-3 d-flex flex-row'
                style={{ marginTop: '-30', marginBottom: -10 }}
              >
                <Col style={{ display: 'flex', alignItems: 'center' }}>
                  <div className=''>
                    <img
                      alt={'st'}
                      src={
                        `${base_logo_url}carrier_logos/` +
                        currentRate?.carrierInfo?.logo
                      }
                      width={isMobile ? 50 : 90}
                    />
                  </div>
                </Col>
                <Col style={{ display: 'flex', alignItems: 'center' }}>
                  <div className='d-block'>
                    <Typography
                      variant={isMobile ? 'body2' : 'h4'}
                      className='fw-bold'
                      style={{ textAlign: 'center' }}
                    >
                      <span className='dayss'>
                        {isNaN(parseInt(currentRate.transitTime))
                          ? 'N/A'
                          : currentRate.transitTime === '0'
                            ? 'N/A'
                            : parseInt(currentRate.transitTime)}
                      </span>
                    </Typography>
                    <Typography
                      variant='body1'
                      className='text-black'
                      style={
                        isMobile
                          ? { fontSize: '9px', textAlign: 'center' }
                          : { fontSize: '13px', textAlign: 'center' }
                      }
                    >
                      Service Day(s)
                    </Typography>
                  </div>
                </Col>
              </Row>
              <Row
                className='px-3 d-flex flex-row'
                style={isMobile ? { width: '150%' } : {}}
              >
                <Col>
                  <div className='my-2'>
                    <Typography
                      variant={isMobile ? 'body2' : 'h6'}
                      className=' '
                      style={{ color: '#1565c0' }}
                    >
                      Origin
                    </Typography>
                    <Typography
                      sx={{ whiteSpace: 'nowrap' }}
                      variant='h5'
                      className={
                        isMobile
                          ? 'info-label-value_mobile'
                          : 'info-label-value'
                      }
                    >
                      {OriginLocation}
                    </Typography>
                  </div>
                </Col>
                <Col>
                  <div className='my-2'>
                    <Typography
                      variant={isMobile ? 'body2' : 'h6'}
                      className=' '
                      style={{ color: '#1565c0' }}
                    >
                      Destination
                    </Typography>
                    <Typography
                      sx={{ whiteSpace: 'nowrap' }}
                      variant='h5'
                      className={
                        isMobile
                          ? 'info-label-value_mobile'
                          : 'info-label-value'
                      }
                    >
                      {DestinationLocation}
                    </Typography>
                  </div>
                </Col>
              </Row>
              <Row
                className='px-3 d-flex flex-row'
                style={isMobile ? { width: '150%' } : {}}
              >
                <Col>
                  <div className='my-2'>
                    <Typography
                      variant={isMobile ? 'body2' : 'h6'}
                      className=''
                      style={{ color: '#1565c0' }}
                    >
                      Weight
                    </Typography>
                    <Typography
                      variant='h5'
                      className={
                        isMobile
                          ? 'info-label-value_mobile'
                          : 'info-label-value'
                      }
                    >{`${OrderWeight} lbs`}</Typography>
                  </div>
                </Col>
                {shipTypeValue !== 'Parcel' && (
                  <Col>
                    <div className='my-2'>
                      <Typography
                        variant={isMobile ? 'body2' : 'h6'}
                        className=' '
                        style={{ color: '#1565c0' }}
                      >
                        Class
                      </Typography>
                      <Typography
                        variant='h5'
                        className={
                          isMobile
                            ? 'info-label-value_mobile'
                            : 'info-label-value'
                        }
                      >
                        {requoteClass}
                      </Typography>
                    </div>
                  </Col>
                )}
              </Row>
              {shipTypeValue !== 'Parcel' && (
                <Row className='px-3 d-flex flex-row ' style={{}}>
                  <Col>
                    <div className='my-2'>
                      <Typography
                        variant={isMobile ? 'body2' : 'h6'}
                        className=''
                        style={{ color: '#1565c0' }}
                      >
                        Quote ID
                      </Typography>
                      <Typography
                        variant='h5'
                        className={
                          isMobile
                            ? 'info-label-value_mobile'
                            : 'info-label-value'
                        }
                      >
                        {currentRate?.quotationNumber}
                      </Typography>
                    </div>
                  </Col>
                </Row>
              )}
              <Row
                className='px-3 d-flex flex-row '
                style={isMobile ? { width: '150%' } : {}}
              >
                <Col>
                  <div className='my-2'>
                    <Typography
                      variant={isMobile ? 'body2' : 'h6'}
                      className=''
                      style={{ color: '#1565c0' }}
                    >
                      Charges Detail
                    </Typography>
                    {currentRate?.surcharges
                      ?.sort(applySubChargesSort)
                      .map(surcharge => (
                        <Typography
                          sx={{ whiteSpace: 'nowrap' }}
                          variant={isMobile ? 'body2' : 'h5'}
                          className={
                            isMobile
                              ? 'info-label-value_mobile'
                              : 'info-label-value'
                          }
                        >{`${surcharge.description}`}</Typography>
                      ))}

                    <Typography
                      variant='body1'
                      className=' fw-bold my-1'
                      style={{ textDecoration: 'underline' }}
                    >
                      Total Price
                    </Typography>
                  </div>
                </Col>
                <Col>
                  <div className='my-2 align-right'>
                    <Typography
                      variant={isMobile ? 'body2' : 'h6'}
                      className=''
                      style={{ color: '#1565c0' }}
                    >
                      Charges
                    </Typography>
                    {currentRate?.surcharges
                      ?.sort(applySubChargesSort)
                      .map(surcharge => (
                        <Typography
                          variant={isMobile ? 'body2' : 'h5'}
                          className={
                            isMobile
                              ? 'info-label-value_mobile'
                              : 'info-label-value'
                          }
                        >
                          {surcharge?.description?.includes('%')
                            ? `${surcharge.amount?.amount.toFixed(2)}%`
                            : formatePrice(surcharge.amount?.amount)}
                        </Typography>
                      ))}
                    <Typography
                      variant='body1'
                      className=' fw-bold my-1'
                      style={{ textDecoration: 'underline' }}
                    >
                      {formatePrice(
                        currentRate?.totalNetCharge?.amount.toFixed(2)
                      )}
                    </Typography>
                  </div>
                </Col>
              </Row>
            </div>
          </Box>
        </Modal>
      </React.Fragment>

      {/* ── Step Indicator ── */}
      <Box sx={{ mb: 2 }}>
        <Stepper activeStep={activeStep} alternativeLabel>
          {['Carrier Rates', 'Pickup Info', 'Preview'].map(label => (
            <Step key={label}>
              <StepLabel
                sx={{
                  '& .MuiStepLabel-label': { fontSize: 12 }
                }}
              >
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>


      {/* ── Preview Screen (step 2) ── */}
      {activeStep === 2 && bookedRate && (
        <Box sx={{ mt: 1 }}>
          {/* Header bar */}
          <Paper
            elevation={0}
            sx={{
              mb: 2,
              p: 1.5,
              border: '1px solid #e2e8f0',
              borderRadius: '10px',
              bgcolor: '#f8fafc',
              display: 'flex',
              flexWrap: 'wrap',
              gap: 2,
              alignItems: 'center'
            }}
          >
            {[
              { label: 'Quote Number', value: bookedRate.quotationNumber || '—' },
              { label: 'Pickup Date', value: obj?.shipmentDate ? new Date(obj.shipmentDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : (obj?.pickupDate || '—') },
              { label: 'Exp. Delivery Date', value: bookedRate.deliveryTime ? new Date(bookedRate.deliveryTime).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '—' },
              { label: 'Transit Time', value: bookedRate.transitTime ? `${bookedRate.transitTime} Days` : '—' },
              { label: 'Mode', value: shipTypeValue || 'LTL' },
              { label: 'PRO #', value: 'Pending' },
              { label: 'BOL #', value: 'Pending' }
            ].map(({ label, value }) => (
              <Box key={label} sx={{ display: 'flex', flexDirection: 'column', minWidth: 90 }}>
                <Typography sx={{ fontSize: 10, color: 'text.secondary', fontWeight: 500, textTransform: 'uppercase', letterSpacing: 0.5 }}>{label}</Typography>
                <Typography sx={{ fontSize: 13, fontWeight: 600, color: value === 'Pending' ? '#94a3b8' : '#1e293b' }}>{value}</Typography>
              </Box>
            ))}
          </Paper>

          {/* SO# and CO# inputs */}
          <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
            <TextField
              size='small'
              label='SO # (Sales Order)'
              value={soNumber}
              onChange={e => setSoNumber(e.target.value)}
              sx={{ flex: 1 }}
              InputProps={{ style: { fontSize: 13 } }}
              InputLabelProps={{ style: { fontSize: 13 } }}
            />
            <TextField
              size='small'
              label='CO # (Customer Order)'
              value={coNumber}
              onChange={e => setCoNumber(e.target.value)}
              sx={{ flex: 1 }}
              InputProps={{ style: { fontSize: 13 } }}
              InputLabelProps={{ style: { fontSize: 13 } }}
            />
          </Box>

          {/* 4-column info cards */}
          <Grid container spacing={2} sx={{ mb: 2 }}>
            {/* Route Information */}
            <Grid item xs={12} sm={3}>
              <Paper elevation={0} sx={{ border: '1px solid #e2e8f0', borderRadius: '10px', p: 2, height: '100%' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                  <Box sx={{ bgcolor: '#eff6ff', borderRadius: '8px', p: 0.6, display: 'flex' }}>
                    <LocationOnIcon sx={{ fontSize: 16, color: '#3b82f6' }} />
                  </Box>
                  <Typography sx={{ fontSize: 13, fontWeight: 600, color: '#1e293b' }}>Route Information</Typography>
                </Box>
                <Box sx={{ mb: 1.5 }}>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.5, mb: 0.5 }}>
                    <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#22c55e', mt: 0.5, flexShrink: 0 }} />
                    <Box>
                      <Typography sx={{ fontSize: 11, color: 'text.secondary', fontWeight: 500 }}>Pickup</Typography>
                      <Typography sx={{ fontSize: 12, fontWeight: 600, color: '#1e293b' }}>
                        {obj?.shipFrom?.city || OriginLocation?.split(' ')[0]}, {obj?.shipFrom?.stateOrProvinceCode || OriginLocation?.split(' ')[1]}
                      </Typography>
                      <Typography sx={{ fontSize: 11, color: 'text.secondary' }}>{obj?.shipFrom?.postalCode || OriginLocation?.split(' ')[2]}</Typography>
                    </Box>
                  </Box>
                  <Box sx={{ borderLeft: '2px dashed #cbd5e1', ml: 0.5, height: 16, my: 0.5 }} />
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.5 }}>
                    <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#ef4444', mt: 0.5, flexShrink: 0 }} />
                    <Box>
                      <Typography sx={{ fontSize: 11, color: 'text.secondary', fontWeight: 500 }}>Delivery</Typography>
                      <Typography sx={{ fontSize: 12, fontWeight: 600, color: '#1e293b' }}>
                        {obj?.shipTo?.city || DestinationLocation?.split(' ')[0]}, {obj?.shipTo?.stateOrProvinceCode || DestinationLocation?.split(' ')[1]}
                      </Typography>
                      <Typography sx={{ fontSize: 11, color: 'text.secondary' }}>{obj?.shipTo?.postalCode || DestinationLocation?.split(' ')[2]}</Typography>
                    </Box>
                  </Box>
                </Box>
              </Paper>
            </Grid>

            {/* Shipment Details */}
            <Grid item xs={12} sm={3}>
              <Paper elevation={0} sx={{ border: '1px solid #e2e8f0', borderRadius: '10px', p: 2, height: '100%' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                  <Box sx={{ bgcolor: '#f0fdf4', borderRadius: '8px', p: 0.6, display: 'flex' }}>
                    <Inventory2OutlinedIcon sx={{ fontSize: 16, color: '#16a34a' }} />
                  </Box>
                  <Typography sx={{ fontSize: 13, fontWeight: 600, color: '#1e293b' }}>Shipment Details</Typography>
                </Box>
                {[
                  { label: 'Shipment Type', value: obj?.shipmentType || '—' },
                  { label: 'Payment Type', value: obj?.paymentType === '0' ? 'Outbound Prepaid' : obj?.paymentType === '1' ? 'Inbound Collect' : obj?.paymentType === '2' ? 'Third Party' : (obj?.paymentType || '—') },
                  { label: 'Service Level', value: bookedRate.serviceType || '—' },
                  obj?.declaredValue && { label: 'Declared Value', value: `$${obj.declaredValue}` },
                  obj?.isHazmat && { label: 'Hazmat', value: 'Yes' }
                ].filter(Boolean).map(({ label, value }) => (
                  <Box key={label} sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                    <Typography sx={{ fontSize: 11, color: 'text.secondary' }}>{label}</Typography>
                    <Typography sx={{ fontSize: 11, fontWeight: 600, color: '#1e293b' }}>{value}</Typography>
                  </Box>
                ))}
              </Paper>
            </Grid>

            {/* Carrier Information */}
            <Grid item xs={12} sm={3}>
              <Paper elevation={0} sx={{ border: '1px solid #e2e8f0', borderRadius: '10px', p: 2, height: '100%' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                  <Box sx={{ bgcolor: '#fef3c7', borderRadius: '8px', p: 0.6, display: 'flex' }}>
                    <LocalShippingOutlinedIcon sx={{ fontSize: 16, color: '#d97706' }} />
                  </Box>
                  <Typography sx={{ fontSize: 13, fontWeight: 600, color: '#1e293b' }}>Carrier Information</Typography>
                </Box>
                {[
                  { label: 'Carrier', value: bookedRate.carrierInfo?.name || '—' },
                  { label: 'Quote Number', value: bookedRate.quotationNumber || '—' },
                  { label: 'Transit Time', value: bookedRate.transitTime ? `${bookedRate.transitTime} Days` : '—' },
                  { label: 'Exp. Delivery', value: bookedRate.deliveryTime ? new Date(bookedRate.deliveryTime).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '—' }
                ].map(({ label, value }) => (
                  <Box key={label} sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                    <Typography sx={{ fontSize: 11, color: 'text.secondary' }}>{label}</Typography>
                    <Typography sx={{ fontSize: 11, fontWeight: 600, color: '#1e293b' }}>{value}</Typography>
                  </Box>
                ))}
              </Paper>
            </Grid>

            {/* Pricing Summary */}
            <Grid item xs={12} sm={3}>
              <Paper elevation={0} sx={{ border: '1px solid #e2e8f0', borderRadius: '10px', p: 2, height: '100%' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                  <Box sx={{ bgcolor: '#fdf4ff', borderRadius: '8px', p: 0.6, display: 'flex' }}>
                    <AttachMoneyIcon sx={{ fontSize: 16, color: '#9333ea' }} />
                  </Box>
                  <Typography sx={{ fontSize: 13, fontWeight: 600, color: '#1e293b' }}>Pricing Summary</Typography>
                </Box>
                {bookedRate.surcharges?.slice().sort((a, b) => (a.order || 0) - (b.order || 0)).map(s => (
                  <Box key={s.description} sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                    <Typography sx={{ fontSize: 11, color: 'text.secondary' }}>{s.description}</Typography>
                    <Typography sx={{ fontSize: 11, fontWeight: 500, color: s.amount?.amount < 0 ? '#ef4444' : '#1e293b' }}>
                      {s.description?.includes('%') ? `${s.amount?.amount?.toFixed(2)}%` : `$${s.amount?.amount?.toFixed(2)}`}
                    </Typography>
                  </Box>
                ))}
                <Divider sx={{ my: 1 }} />
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography sx={{ fontSize: 12, fontWeight: 700, color: '#1e293b' }}>Total Price</Typography>
                  <Typography sx={{ fontSize: 14, fontWeight: 700, color: '#1d4ed8' }}>
                    ${bookedRate.totalNetCharge?.amount?.toFixed(2)}
                  </Typography>
                </Box>
                {bookedRate.isGuaranteedDelviery && (
                  <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 0.5, bgcolor: '#f0fdf4', borderRadius: '6px', p: 0.75 }}>
                    <CheckCircleOutlineIcon sx={{ fontSize: 14, color: '#16a34a' }} />
                    <Typography sx={{ fontSize: 10, color: '#16a34a', fontWeight: 600 }}>Guaranteed Price</Typography>
                  </Box>
                )}
              </Paper>
            </Grid>
          </Grid>

          {/* Commodity Information (horizontal) */}
          <Paper elevation={0} sx={{ border: '1px solid #e2e8f0', borderRadius: '10px', p: 2, mb: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
              <Box sx={{ bgcolor: '#fff7ed', borderRadius: '8px', p: 0.6, display: 'flex' }}>
                <Inventory2OutlinedIcon sx={{ fontSize: 16, color: '#ea580c' }} />
              </Box>
              <Typography sx={{ fontSize: 13, fontWeight: 600, color: '#1e293b' }}>Commodity Information</Typography>
            </Box>
            <Box sx={{ overflowX: 'auto' }}>
              <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(9, minmax(80px, 1fr))', gap: 0, minWidth: 600 }}>
                {['Commodity / Item', 'NMFC', 'Class', 'Quantity', 'Units', 'Pieces', 'Weight (lbs)', 'Stackable', 'Hazmat'].map(h => (
                  <Typography key={h} sx={{ fontSize: 10, fontWeight: 700, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.3, p: '6px 8px', bgcolor: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>{h}</Typography>
                ))}
                {(obj?.commodityInfo || []).map((c, i) => {
                  const wt = parseFloat(c.weight || c.totalClassWeight || 0);
                  return [
                    c.description || c.commodity || '—',
                    c.nmfc || '—',
                    c.freightClass || '—',
                    c.units || '—',
                    c.packaging || c.unitType || '—',
                    c.pieces || '—',
                    wt > 0 ? wt.toLocaleString() : '—',
                    c.isStackable ? 'Yes' : 'No',
                    c.isHazmat ? 'Yes' : 'No'
                  ].map((val, j) => (
                    <Typography key={j} sx={{ fontSize: 12, color: j === 7 && val === 'Yes' ? '#16a34a' : j === 8 && val === 'Yes' ? '#ef4444' : '#1e293b', fontWeight: j === 7 && val === 'Yes' || j === 8 && val === 'Yes' ? 600 : 400, p: '6px 8px', borderBottom: '1px solid #f1f5f9' }}>{val}</Typography>
                  ));
                })}
              </Box>
            </Box>
          </Paper>

          {/* Action buttons */}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1.5 }}>
            <Button
              variant='outlined'
              onClick={() => { setActiveStep(0); setBookedRate(null); }}
              sx={{ textTransform: 'none', fontSize: 13, borderRadius: '8px', borderColor: '#d1d5db', color: '#374151', '&:hover': { borderColor: '#9ca3af' } }}
            >
              Back
            </Button>
            <Button
              variant='contained'
              onClick={handleConfirmPickup}
              startIcon={<LocalShippingOutlinedIcon sx={{ fontSize: 17 }} />}
              sx={{ textTransform: 'none', fontSize: 13, borderRadius: '8px', bgcolor: '#1d4ed8', '&:hover': { bgcolor: '#1e40af' } }}
            >
              Confirm Pickup
            </Button>
          </Box>
        </Box>
      )}

      {activeStep === 0 && (
      <div className='w-100'>
        {/* ── Filter tabs + Sort ── */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            mb: 0.5
          }}
        >
          <Tabs
            onChange={handleFilterValueChange}
            value={filterValue}
            aria-label='rate filter tabs'
            selectionFollowsFocus
          >
            <Tab
              sx={{ fontSize: 13, minWidth: 'auto', textTransform: 'none', fontWeight: 600 }}
              onClick={() => setFilterKey('*')}
              label={`All (${successRates.length})`}
            />
            <Tab
              sx={{ fontSize: 13, minWidth: 'auto', textTransform: 'none', fontWeight: 600 }}
              onClick={() => setFilterKey('standard')}
              label={`Standard (${successRates.filter(r => r.filterMode === 'standard').length})`}
            />
            <Tab
              sx={{ fontSize: 13, minWidth: 'auto', textTransform: 'none', fontWeight: 600 }}
              onClick={() => setFilterKey('guaranteed')}
              label={`Guaranteed (${successRates.filter(r => r.isGuaranteedDelviery).length})`}
            />
          </Tabs>

          {/* Sort by text buttons */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Typography sx={{ fontSize: 13, color: 'text.secondary', mr: 0.5 }}>
              Sort by:
            </Typography>
            {[
              { key: 'price', label: 'Price' },
              { key: 'days', label: 'Days' },
              { key: 'name', label: 'Carrier A-Z' }
            ].map(({ key, label }) => (
              <Typography
                key={key}
                onClick={() => {
                  if (sortKey === key) {
                    setSortOrder(o => (o === 'ASC' ? 'DESC' : 'ASC'));
                  } else {
                    setSortKey(key);
                    setSortOrder('ASC');
                  }
                }}
                sx={{
                  fontSize: 13,
                  fontWeight: sortKey === key ? 700 : 400,
                  color: sortKey === key ? 'primary.main' : 'text.secondary',
                  textDecoration: sortKey === key ? 'underline' : 'none',
                  cursor: 'pointer',
                  px: 0.75,
                  '&:hover': { color: 'primary.main' }
                }}
              >
                {label}
              </Typography>
            ))}
          </Box>
        </Box>

        {/* ── Column headers ── */}
        {!isMobile && (
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: '1.6fr 1.4fr 1.2fr 1fr',
              px: 2,
              py: 0.75,
              borderBottom: '1px solid',
              borderColor: 'divider',
              bgcolor: '#f8fafc',
              borderRadius: '4px 4px 0 0'
            }}
          >
            {[
              { label: 'Carrier' },
              { label: 'Price', icon: sortKey === 'price' ? (sortOrder === 'ASC' ? ' ↓' : ' ↑') : '' },
              { label: 'Transit Time (Days)', icon: sortKey === 'days' ? (sortOrder === 'ASC' ? ' ↓' : ' ↑') : '' },
              { label: '' }
            ].map(({ label, icon }, i) => (
              <Typography
                key={i}
                sx={{ fontSize: 12, fontWeight: 600, color: 'text.secondary' }}
              >
                {label}{icon}
              </Typography>
            ))}
          </Box>
        )}
        <div
          className={
            isMobile
              ? 'rates-data-container_quick_quote_mobile'
              : 'rates-data-container_quick_quote'
          }
        >
          {EstesApiLoading ? (
            LoadingArray.map(items => (
              <div className='Error_Carrier_div w-100'>
                <Row
                  style={{
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  {/* <div
                  style={
                    EstesApiLoading
                      ? {
                          width: 60,
                          fontSize: 12,
                          fontWeight: 700,
                          position: 'absolute',
                          margin: '-90 0 0 20',
                          backgroundColor: 'white',
                          whiteSpace: 'nowrap'
                        }
                      : {
                          width: 'auto',
                          fontSize: 12,
                          fontWeight: 700,
                          position: 'absolute',
                          margin: '-90 0 0 20',
                          backgroundColor: 'white',
                          whiteSpace: 'nowrap'
                        }
                  }
                ></div> */}
                  <Col lg={3} xs={2}>
                    <Box
                      sx={
                        isMobile
                          ? {
                              height: 30,
                              margin: 1
                            }
                          : {
                              height: 60,
                              margin: '20 0 0 17'
                            }
                      }
                    >
                      <Skeleton
                        variant='circular'
                        width={isMobile ? 30 : 40}
                        height={isMobile ? 30 : 40}
                      />
                    </Box>
                  </Col>
                  <Col lg={2} xs={2}>
                    <div style={{ cursor: 'pointer' }}>
                      <h2>
                        <Box sx={{ width: isMobile ? 35 : 120 }}>
                          <Skeleton />
                        </Box>
                      </h2>

                      <span
                        style={{
                          width: 'auto',
                          fontSize: 10,
                          fontWeight: 700,
                          position: 'absolute',
                          margin: '-14 0 0 0',
                          cursor: 'auto'
                        }}
                      >
                        <Box
                          sx={{ width: isMobile ? 35 : 100, marginTop: 0.5 }}
                        >
                          <Skeleton />
                        </Box>
                      </span>
                    </div>
                  </Col>
                  <Col lg={3} xs={3}>
                    <div
                      style={{
                        display: 'flex',
                        marginTop: 15
                      }}
                    >
                      <div>
                        <span
                          style={{
                            fontSize: 11,
                            fontWeight: 700
                          }}
                        >
                          <Box sx={{ width: isMobile ? 40 : 110 }}>
                            <Skeleton />
                          </Box>
                          <br />
                          <span
                            style={{
                              fontSize: 11,
                              fontWeight: 'normal'
                            }}
                          >
                            <Box
                              sx={{ width: isMobile ? 30 : 80, marginTop: -2 }}
                            >
                              <Skeleton />
                            </Box>
                          </span>
                        </span>
                      </div>{' '}
                      <div>
                        <span
                          style={{
                            fontSize: 11,
                            fontWeight: 700,
                            margin: '0 0 0 18'
                          }}
                        >
                          <Box
                            sx={{ width: isMobile ? 40 : 110, marginLeft: 3 }}
                          >
                            <Skeleton />
                          </Box>
                          <br />
                          <span
                            style={{
                              fontSize: 11,
                              fontWeight: 'normal',
                              margin: '0 0 0 18'
                            }}
                          >
                            <Box
                              sx={{
                                width: isMobile ? 30 : 80,
                                marginTop: -2,
                                marginLeft: 3
                              }}
                            >
                              <Skeleton />
                            </Box>
                          </span>
                        </span>
                      </div>
                    </div>
                  </Col>
                  <Col lg={3} xs={isMobile ? 4 : 3}>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'end',
                        marginTop: 15
                      }}
                    >
                      <div>
                        <span
                          style={{
                            fontSize: 11,
                            fontWeight: 700,
                            margin: '0 0 0 18'
                          }}
                        >
                          <Box
                            sx={{ width: isMobile ? 40 : 110, marginLeft: 3 }}
                          >
                            <Skeleton />
                          </Box>
                          <br />
                          <span
                            style={{
                              fontSize: 11,
                              fontWeight: 'normal',
                              margin: '0 0 0 18'
                            }}
                          >
                            <Box
                              sx={{
                                width: isMobile ? 30 : 80,
                                marginTop: -2,
                                marginLeft: 3
                              }}
                            >
                              <Skeleton />
                            </Box>
                          </span>
                        </span>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            ))
          ) : (
            <>
              {successRates
                .filter(applyFilter)
                .sort(applySort)
                .map((item, index) => (
                  <Box
                    key={item.uniqueId || index}
                    onClick={() => onSelectRate && handleSelectRate(item)}
                    sx={{
                      display: 'grid',
                      gridTemplateColumns: isMobile ? '1fr 1fr' : '1.6fr 1.4fr 1.2fr 1fr',
                      alignItems: 'center',
                      px: 2,
                      py: 1.25,
                      borderBottom: '1px solid #f1f5f9',
                      borderLeft: isSelected(item) ? '3px solid #1D9E75' : '3px solid transparent',
                      bgcolor: isSelected(item) ? 'rgba(29,158,117,0.04)' : 'white',
                      cursor: onSelectRate ? 'pointer' : 'default',
                      transition: 'background-color 0.15s',
                      '&:hover': { bgcolor: '#f8fafc' }
                    }}
                  >
                    {/* Carrier logo */}
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <img
                        alt={item.carrierInfo?.name || ''}
                        src={`${base_logo_url}carrier_logos/` + item?.carrierInfo?.logo}
                        style={{ maxWidth: isMobile ? 60 : 100, maxHeight: 44, objectFit: 'contain' }}
                      />
                    </Box>

                    {/* Price */}
                    <Box>
                      <Typography sx={{ fontSize: isMobile ? 15 : 18, fontWeight: 700, color: '#111827', lineHeight: 1.2 }}>
                        {formatePrice(item.totalNetCharge.amount)}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: 12,
                          fontWeight: 500,
                          color: item.isGuaranteedDelviery ? '#16a34a' : '#6b7280',
                          mt: 0.25
                        }}
                      >
                        {item.isGuaranteedDelviery ? 'Guaranteed' : 'Standard'}
                      </Typography>
                    </Box>

                    {/* Transit time */}
                    <Box>
                      <Typography sx={{ fontSize: isMobile ? 13 : 16, fontWeight: 700, color: '#111827', lineHeight: 1.2 }}>
                        {isNaN(parseInt(item.transitTime)) || item.transitTime === '0'
                          ? 'N/A'
                          : `${parseInt(item.transitTime)} Days`}
                      </Typography>
                      <Typography sx={{ fontSize: 11, color: '#6b7280', mt: 0.25 }}>
                        {item.deliveryTime
                          ? new Date(item.deliveryTime).toLocaleString('en-US', {
                              month: 'long',
                              day: 'numeric',
                              year: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit'
                            })
                          : ''}
                      </Typography>
                    </Box>

                    {/* Actions */}
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 0.75 }}>
                      <IconButton size='small' sx={{ color: '#9ca3af' }}>
                        <BookmarkBorderIcon sx={{ fontSize: 17 }} />
                      </IconButton>
                      <Button
                        variant='outlined'
                        size='small'
                        onClick={e => { e.stopPropagation(); handleViewRate1(item); }}
                        sx={{
                          textTransform: 'none',
                          fontSize: isMobile ? 10 : 12,
                          whiteSpace: 'nowrap',
                          borderColor: '#d1d5db',
                          color: '#374151',
                          '&:hover': { borderColor: '#9ca3af' }
                        }}
                      >
                        View Details
                      </Button>
                      <Button
                        variant='contained'
                        size='small'
                        onClick={e => { e.stopPropagation(); handleBookRate(item); }}
                        sx={{
                          textTransform: 'none',
                          fontSize: isMobile ? 10 : 12,
                          whiteSpace: 'nowrap',
                          bgcolor: '#1d4ed8',
                          '&:hover': { bgcolor: '#1e40af' }
                        }}
                      >
                        Book
                      </Button>
                    </Box>
                  </Box>
                ))}

              {checked &&
                ErrMsgArray?.map((item, index) => (
                  <div
                    className='filter-item errs  p-2'
                    style={{ width: '100%' }}
                  >
                    <Row className='table-card'>
                      <Col
                        xs={2}
                        className='d-flex flex-row h-100'
                        style={{ alignItems: 'center' }}
                      >
                        <img
                          style={isMobile ? { marginLeft: -14 } : {}}
                          alt=''
                          // className='table-card-logo'
                          src={item?.logo?.logo}
                          width={isMobile ? 50 : 90}
                          // height={isMobile ? 45 : 90}
                        />
                      </Col>
                      <Col
                        className='d-flex flex-row h-100'
                        style={{ alignItems: 'center' }}
                      >
                        <RateErrorTooltip
                          title={item.msg.length > 90 ? item.msg : ''}
                          placement='top'
                          arrow
                          style={{ backgroundColor: '#c21919', color: 'white' }}
                        >
                          <Typography
                            variant={isMobile ? 'body2' : 'h6'}
                            className={
                              isMobile
                                ? 'text-white px-1 py-1'
                                : ' text-white px-2 py-1'
                            }
                            style={
                              isMobile
                                ? {
                                    fontSize: '9px',
                                    backgroundColor: '#c21919',
                                    borderRadius: '6px'
                                  }
                                : {
                                    fontSize: '13px',
                                    backgroundColor: '#c21919',
                                    borderRadius: '6px'
                                  }
                            }
                          >
                            {item.msg.substring(0, 100)}
                          </Typography>
                        </RateErrorTooltip>
                      </Col>
                    </Row>
                  </div>
                ))}
            </>
          )}
          {noAssignedCarriers && (
            <div style={{ marginTop: '20vh' }}>
              <div class='alert alert-info' role='alert'>
                One or more carriers have not been configured for the selected
                location "{selectedLocation?.location}".{' '}
                <a
                  href={`/view-locations?location=${encodeURIComponent(
                    selectedLocation?.location
                  )}?${shipTypeValue}`}
                >
                  Click here to Configure
                </a>
                .
              </div>
            </div>
          )}
        </div>
      </div>
      )}

    </div>
  );
}

export default QuickQuoteTabPanel;
